export default __webpack_public_path__ + "static/media/preloader.d3fad06d.svg";